<template>
  <div id="dialogCrearAdministrador">
    <v-dialog
      v-model="getCreateNewDialog"
      persistent
      max-width="1200px">
      <v-card>
        <v-card-title>Nueva Noticia</v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="formNew">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newData.title"
                    label="Titulo"
                    required
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newData.subtitle"
                    label="Subtitulo"
                    required
                    outlined
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="newData.tags"
                    label="Etiquetas"
                    outlined
                    hint="Separar por comas"
                    dense>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    v-model="image"
                    label="Imagen"
                    outlined
                    dense
                    required
                    accept="image/*"
                    @change="onFileSelected"
                    persistent-hint>
                  </v-file-input>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor
                    v-model="newData.content"
                    placeholder="Contenido de la noticia"
                    useCustomImageHandler
                    @image-added="handleImageAdded">
                  </VueEditor>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="createUpdateNew">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    VueEditor
  },
  data: function () {
    return {
      image: null,
      newData: {
        // id: 2,
        title: '',
        subtitle: '',
        tags: '',
        content: '',
        image: ''
      }
    };
  },

  computed: {
    ...mapGetters('admin', ['getCreateNewDialog'])
  },

  methods: {
    async onFileSelected (file) {
      if (!file) return;
      let url = await this.fetchNewAddImagen(file);
      if (url) {
        this.newData.image = url;
      }
    },
    async createUpdateNew () {
      if (this.$refs.formNew.validate()) {
        let success = await this.fetchCreateNew(this.newData);
        if (success) {
          this.newData = {
            // id: 2,
            title: '',
            subtitle: '',
            tags: '',
            content: '',
            image: ''
          };
          await this.fetchListaNew();
          this.closeDialog();
        }
      }
    },

    closeDialog () {
      this.setCreateNewDialog(false);
    },

    handleImageAdded: async function (file, Editor, cursorLocation, resetUploader) {
      let url = await this.fetchNewAddImagen(file);
      if (url) {
        Editor.insertEmbed(cursorLocation, 'image', url);
      }
      resetUploader();
    },

    ...mapMutations('admin', ['setCreateNewDialog']),

    ...mapActions('admin', ['fetchCreateNew', 'fetchListaNew', 'fetchNewAddImagen'])
  }
};
</script>

<style>
</style>
